export enum Flag {
  None = 0,
  Inappropriate = 1,
}
